(() => {
  if (window.gpChristmasCheckoutInstalled) return;
  window.gpChristmasCheckoutInstalled = true;
  const treeId = 7983558951098;
  const pickupLocation = 'gid://shopify/Location/58329563322';
  const mutation = `mutation($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      cart { buyerIdentity { preferences { delivery { deliveryMethod pickupHandle } } } }
      userErrors { message }
    }
  }`;
  let busy = false;
  let resumeForm = null;
  const root = () => window.Shopify?.routes?.root || '/';
  const isZh = () => document.documentElement.lang.startsWith('zh');

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal});
      if (!response.ok) throw new Error('Request failed');
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }

  async function syncPreference() {
    const cart = await request(`${root()}cart.js`, {cache: 'no-store'});
    const trees = cart.items.filter(item => Number(item.product_id) === treeId);
    if (!trees.length) return;
    const pickup = trees.some(item => /^Pickup\b/i.test(item.properties?.['Christmas fulfilment preference'] || ''));
    const method = pickup ? 'PICK_UP' : 'SHIPPING';
    const delivery = {deliveryMethod: [method], pickupHandle: pickup ? [pickupLocation] : []};
    if (!cart.token) throw new Error('Cart unavailable');
    const result = await request('/api/2026-07/graphql.json', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({query: mutation, variables: {
        cartId: `gid://shopify/Cart/${cart.token}`,
        buyerIdentity: {preferences: {delivery}}
      }})
    });
    const updated = result.data?.cartBuyerIdentityUpdate;
    if (result.errors?.length || !updated || updated.userErrors?.length ||
        updated.cart?.buyerIdentity?.preferences?.delivery?.deliveryMethod?.[0] !== method) {
      throw new Error('Delivery preference was not saved');
    }
  }

  async function checkout(trigger, resume) {
    if (busy) return;
    busy = true;
    const wasDisabled = trigger.disabled;
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    let error = trigger.parentElement.querySelector('[data-gp-checkout-error]');
    if (error) error.remove();
    try {
      await syncPreference();
      trigger.disabled = wasDisabled;
      resume();
    } catch {
      error = document.createElement('p');
      error.dataset.gpCheckoutError = '';
      error.setAttribute('role', 'alert');
      error.textContent = isZh() ? '暫時無法確認送貨／自取方式，請重試結帳。' : 'We could not confirm delivery / pickup. Please try again.';
      trigger.insertAdjacentElement('afterend', error);
    } finally {
      busy = false;
      trigger.disabled = wasDisabled;
      trigger.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (resumeForm === form) {
      resumeForm = null;
      return;
    }
    if (!(form instanceof HTMLFormElement) || event.submitter?.name !== 'checkout') return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/?$/.test(action.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter;
    checkout(button, () => {
      resumeForm = form;
      try { form.requestSubmit(button); } finally { resumeForm = null; }
    });
  }, true);

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(link, () => location.assign(url.href));
  }, true);
})();
